import React from "react";
import { withRouter } from "react-router-dom";
import PageHeader from "../views/pageHeader/PageHeader.js";
import Footer from "../views/footer/Footer.js";
import PropTypes from 'prop-types';
// import _authService from "modules/authService";

class PrivateLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state={
            depList:[]
        }
    }

    updateDepartment = (selectedDeps) => {
        this.setState({depList: selectedDeps});
    }
    
    render() {
        return (
            <div className="fullPage">
                {/* <PageHeader depList={this.state.depList}/> */}
                    {React.cloneElement(this.props.children, { updateDepartment:this.updateDepartment } )}
                {/* <Footer /> */}
            </div>
        );
    }
}

PrivateLayout.propTypes = {
    children:PropTypes.node
};

export default withRouter(PrivateLayout);
